import React from 'react';
export var EditIcon = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M837 187c45 44 66 107 56 169-1 4-3 8-6 11L387 866c-4 6-10 9-16 10l-121 12h-5l-94 9h-2c-6 0-12-2-16-6-4-5-6-11-6-17l21-220c1-7 4-13 10-17l499-500c3-3 7-5 12-6 60-10 122 10 165 53zm-155-14L231 625c29 5 56 23 73 50 2 3 4 6 5 10l482-482c-31-24-70-35-109-30zm170 169c4-39-7-78-31-108L340 714l12 7c26 17 43 43 48 72zM354 835c11-28 1-61-25-77-9-6-21-10-32-10h-1c-10-1-19-9-19-19v-2c-1-10-4-21-10-30-16-27-49-38-78-27l-9 92c39 12 69 43 81 82zm-178-29l-4 46 46-4c-8-19-23-34-42-42z"
}));